import { render } from "./footer.vue?vue&type=template&id=0920956e&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=0920956e&lang=scss&scoped=true"
import "./footer.vue?vue&type=style&index=1&id=0920956e&lang=scss&scoped=true"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0920956e"]])

export default __exports__